import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class SubDivisionService {
  static async getSubDivisions(params = {}) {
    const response = await axiosInstance.get(
      API_PATHS.getsubdivisions,
      { params }
    );
    return response.data;
  }

  static async getSubDivisionById(id) {
    const response = await axiosInstance.get(
      `admin/subdivisions/${id}`
    );
    return response.data;
  }

  static async createSubDivision(payload) {
    const response = await axiosInstance.post(
      API_PATHS.getsubdivisions,
      payload
    );
    return response.data;
  }

  static async updateSubDivision(id, payload) {
    const response = await axiosInstance.put(
      `admin/subdivisions/${id}`,
      payload
    );
    return response.data;
  }

  static async deleteSubDivision(id) {
    const response = await axiosInstance.delete(
      `admin/subdivisions/${id}`
    );
    return response.data;
  }
}

export default SubDivisionService;